import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e011fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = { class: "question-label" }
const _hoisted_5 = { class: "mt-4 font-light" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "flex flex-grow justify-center items-center align-middle" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/worldicon.png",
  class: "w-16 h-16",
  alt: "World icon"
}, null, -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flex flex-row items-center p-2 mb-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "bg-project border-project-dark border rounded-sm p-4 flex flex-col" }
const _hoisted_15 = { class: "flex flex-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/scirt/worldicon.png",
  class: "w-16 h-16 mr-2",
  alt: "World icon"
}, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "ml-4 text-base list-disc font-normal" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "mr-16" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "float-right ml-2 w-1/2",
  src: "img/scirt/slide2readmoreimage.jpg",
  alt: "Clothes pile"
}, null, -1))
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 0,
  class: "bottom-0 sm:absolute p-2 sm:max-w-half"
}
const _hoisted_29 = ["href", "innerHTML"]
const _hoisted_30 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.config.title), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", {
                class: "",
                innerHTML: _ctx.$t(_ctx.config.textPart1)
              }, null, 8, _hoisted_6),
              _createElementVNode("p", {
                class: "mt-4",
                innerHTML: _ctx.$t(_ctx.config.textPart2)
              }, null, 8, _hoisted_7)
            ]),
            _createVNode(_component_BackNextButtons, {
              class: "hidden sm:block mt-auto",
              "go-to": _ctx.moveNext,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-4 h-full min-h-50vh flex-col items-center flex relative min-h-75vh sm:min-h-0",
            style: _normalizeStyle(_ctx.config.bgStyles)
          }, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.slides, (slideImage, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex flex-col"
                }, [
                  (_ctx.config.slidesReadMore[index])
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showReadMoreModal = true;}),
                        class: "right-0 top-0 absolute flex flex-row align-middle justify-center items-center p-2 cursor-pointer"
                      }, [
                        _hoisted_9,
                        _createElementVNode("button", {
                          href: _ctx.$t(_ctx.config.slidesReadMore[index]),
                          class: "lowercase text-gray-900 hover:text-gray-600 font-bold text-sm"
                        }, _toDisplayString(_ctx.$t('texts.readmore')) + " > ", 9, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: slideImage,
                    class: "w-full"
                  }, null, 8, _hoisted_11)
                ])), [
                  [_vShow, _ctx.slide == index]
                ])
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.slides, (_, slideIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: slideIndex,
                  class: _normalizeClass(["mr-2 rounded-full bg-white h-4 w-4 cursor-pointer", {'active-slide-indicator': _ctx.slide == slideIndex}]),
                  onClick: ($event: any) => (_ctx.slide = slideIndex)
                }, null, 10, _hoisted_13))
              }), 128))
            ])
          ], 4),
          _createVNode(_component_Modal, {
            "max-width": "800px",
            modelValue: _ctx.showReadMoreModal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showReadMoreModal) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showReadMoreModal = false)),
                  class: "absolute top-2 right-4 text-white font-bold text-3xl text-right"
                }, " × "),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  (_ctx.slide == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("h3", {
                          class: "text-white mb-4 mt-2 uppercase text-4xl",
                          innerHTML: _ctx.$t(_ctx.config.readMoreModal.title)
                        }, null, 8, _hoisted_18),
                        _createElementVNode("ul", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.readMoreModal.slide0, (text, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              innerHTML: _ctx.$t(text)
                            }, null, 8, _hoisted_20))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.slide == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("h3", {
                          class: "text-white mb-4 mt-2 uppercase text-4xl",
                          innerHTML: _ctx.$t(_ctx.config.readMoreModal.title)
                        }, null, 8, _hoisted_22),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("p", {
                            class: "text-lg font-normal",
                            innerHTML: _ctx.$t(_ctx.config.readMoreModal.slide1.text1)
                          }, null, 8, _hoisted_25)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.slide == 0)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "text-xs text-black mt-4",
                      innerHTML: _ctx.$t(_ctx.config.readMoreModal.sources.slide0)
                    }, null, 8, _hoisted_26))
                  : _createCommentVNode("", true),
                (_ctx.slide == 1)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "text-xs text-black mt-4",
                      innerHTML: _ctx.$t(_ctx.config.readMoreModal.sources.slide1)
                    }, null, 8, _hoisted_27))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_BackNextButtons, {
          class: "block sm:hidden mt-4",
          "go-to": _ctx.moveNext,
          "next-screen": _ctx.config.screenNext
        }, null, 8, ["go-to", "next-screen"]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.$t(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_29))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_30))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}